import { Component, OnInit, ViewEncapsulation, QueryList, ViewChildren, ViewChild, HostListener } from '@angular/core';
import { Driver } from '../../shared/driver.model';
import { MapObject } from '../../shared/mapobject.model';
import { DataService } from '../../core/data.service';
import { SearchService } from 'src/app/core/search.service';
import { SelectService } from 'src/app/core/select.service';
import { NgForm, NgModel } from '@angular/forms';

@Component({
    selector: 'app-driver-list',
    templateUrl: './driver-list.component.html',
    styleUrls: ['./driver-list.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class DriverListComponent implements OnInit {
    // data properties
    driver: Driver;
    data: Driver[];
    filteredResult: Driver[];
    errorMessage: string;
    // search properties
    @ViewChild('form') form: NgForm;
    @ViewChildren(NgModel) fields: QueryList<NgModel>;
    orderNumber: string;
    requestNumber: string;
    plantName: string;
    clientName: string;
    address: string;
    name: string;
    phone: string;
    carNumber: string;
    carrier: string;
    status: string;
    deliveryStatus: string;
    searchOrderNumber: string;
    searchRequestNumber: string;
    searchPlantName: string;
    searchClientName: string;
    searchAddress: string;
    searchName: string;
    searchPhone: string;
    searchCarNumber: string;
    searchCarrier: string;
    searchStatus: string;
    searchDeliveryStatus: string;
    // selected properties
    selectedDriverId: Driver;
    selectedDrivers: Driver[];
    selectedAddress: Driver[];
    selectedMapObject: MapObject;
    isSelected: boolean;
    // table properties
    page = 1;
    pageSize = 5;
    maxSizeDesktop = 5;
    maxSizeMobile = 2;
    // responsive properties
    driversDesktop: boolean;

    constructor(
        private dataService: DataService,
        private searchService: SearchService,
        private selectService: SelectService) { }

    ngOnInit() {
        // data methods
        this.dataService.drivers$.subscribe(
            drivers => {
                this.data = drivers;
            }
        );
        this.selectedDrivers = this.data.filter(driver => driver.checked === true);
        this.selectedAddress = this.data.filter(address => address.checked_plant === true);
        // search methods
        this.searchService.searchOrderNumber$.subscribe(
            req => this.searchOrderNumber = req
        );
        this.searchService.searchRequestNumber$.subscribe(
            req => this.searchRequestNumber = req
        );
        this.searchService.searchPlantName$.subscribe(
            req => this.searchPlantName = req
        );
        this.searchService.searchClientName$.subscribe(
            req => this.searchClientName = req
        );
        this.searchService.searchAddress$.subscribe(
            req => this.searchAddress = req
        );
        this.searchService.searchName$.subscribe(
            req => this.searchName = req
        );
        this.searchService.searchPhone$.subscribe(
            req => this.searchPhone = req
        );
        this.searchService.searchCarNumber$.subscribe(
            req => this.searchCarNumber = req
        );
        this.searchService.searchCarrier$.subscribe(
            req => this.searchCarrier = req
        );
        this.searchService.searchStatus$.subscribe(
            req => this.searchStatus = req
        );
        this.searchService.searchDeliveryStatus$.subscribe(
            req => this.searchDeliveryStatus = req
        );
        // selected methods
        this.selectService.selectedDriverId$.subscribe(
            id => this.selectedDriverId = id
        );
        this.selectService.isSelected$.subscribe(
            picked => this.isSelected = picked
        );
        // responsive methods
        if (window.screen.width >= 769) {
            this.driversDesktop = true;
        }
    }

    @HostListener('window:resize', [])
    onResize() {
        const width = window.innerWidth;
        if (width >= 769) {
            this.driversDesktop = true;
        } else {
            this.driversDesktop = false;
        }
    }

    onSelect(driver: Driver) {
        this.selectService.getSelectedDriverId(driver);
        this.isSelected = true;
        this.selectService.getSelectedState(this.isSelected);
        console.log(this.selectedDriverId);
        console.log(this.isSelected);
    }

    checkAllDrivers() {
        if (!this.selectedDrivers.find(driver => driver.shipment_id === -1)) {
            this.selectedDrivers = this.data.map(
                driver => driver,                
            ).filter(
                driver => driver.tracking === 'online'
            );
            this.selectedDrivers.map(
                driver => driver.checked = true
            );
        }
        this.selectService.getSelectedDrivers(this.selectedDrivers);
        console.log(this.selectedDrivers);
    }

    unCheckAllDrivers() {
        this.selectedDrivers.map(
            driver => driver.checked = false
        );
        this.selectedDrivers = [];
        this.selectService.getSelectedDrivers([]);
        console.log(this.selectedDrivers);
    }

    checkAllAddresses() {
        if (!this.selectedAddress.find(driver => driver.shipment_id === -1)) {
            this.selectedAddress = this.data.map(
                driver => driver
            );
            this.selectedAddress.map(
                driver => driver.checked_plant = true
            );
        }
        this.selectService.getSelectedAddress(this.selectedAddress);
        console.log(this.selectedAddress);
    }

    unCheckAllAddresses() {
        this.selectedAddress.map(
            driver => driver.checked_plant = false
        );
        this.selectedAddress = [];
        this.selectService.getSelectedAddress([]);
        console.log(this.selectedAddress);
    }

    checkAddress(driver: Driver) {
        if (this.selectedAddress.find(a => a.shipment_id === driver.shipment_id)) {
            this.selectedAddress.splice(this.selectedAddress.indexOf(driver), 1);
            driver.checked_plant = false;            
            console.log(this.selectedAddress);
        } else {            
            driver.checked_plant = true;
            this.selectedAddress.push(driver);
            console.log(this.selectedAddress);
            this.selectService.getSelectedMapObject({lat: driver.address_geo_lat, lng: driver.address_geo_lon});
        }
        this.selectService.getSelectedAddress(this.selectedAddress);        
    }

    checkDriver(driver: Driver) {
        if (this.selectedDrivers.find(d => d.shipment_id === driver.shipment_id)) {            
            driver.checked = false;
            this.selectedDrivers.splice(this.selectedDrivers.indexOf(driver), 1);           
            console.log(this.selectedDrivers);
        } else {
            this.selectedDrivers.push(driver);
            driver.checked = true;
            console.log(this.selectedDrivers);
            this.selectService.getSelectedMapObject({lat: driver.geo_lat, lng: driver.geo_lon});
        }
        this.selectService.getSelectedDrivers(this.selectedDrivers);        
    }

    removeDuplicates(data: any) {
        return data.filter((value: any, index: any) => data.indexOf(value) === index);
    }

    // addSelectedDriver(driver: Driver) {        
    //     if (this.selectedDrivers.indexOf(driver.shipment_id)) {
    //         this.selectedDrivers.push(driver);
    //     } 
    //     this.selectedDrivers.map(d => {
    //         if (d === driver) {
    //             d.checked = true;
    //             console.log(d);
    //         }
    //     });       
    //     console.log('push');
    //     this.removeDuplicates(this.selectedDrivers);
    //     this.selectService.getSelectedDrivers(this.selectedDrivers);
    //     console.log(this.selectedDrivers);
    // }

    // removeSelectedDriver(driver: Driver) {        
    //     this.selectedDrivers.map(d => {
    //         if (d === driver) {
    //             d.checked = false;
    //             console.log(d);
    //         }
    //     });
    //     this.selectedDrivers.splice(this.selectedDrivers.indexOf(driver.shipment_id), 1);
    //     console.log('splice');
    //     this.selectService.getSelectedDrivers(this.selectedDrivers);
    //     console.log(this.selectedDrivers);
    // }

    // addSelectedAddress(driver: Driver) {
    //     if (this.selectedAddress.indexOf(driver.shipment_id)) {
    //         this.selectedAddress.push(driver);
    //     }
    //     this.selectedAddress.map(d => {
    //         if (d === driver) {
    //             d.checked_plant = true;
    //             console.log(d);
    //         }
    //     });
    //     console.log('push');
    //     this.selectService.getSelectedAddress(this.selectedAddress);
    //     console.log(this.selectedAddress);
    // }

    // removeSelectedAddress(driver: Driver) {
    //     this.selectedAddress.map(d => {
    //         if (d === driver) {
    //             d.checked_plant = false;
    //             console.log(d);
    //         }
    //     });
    //     this.selectedAddress.splice(this.selectedAddress.indexOf(driver.shipment_id), 1);
    //     console.log('splice');
    //     this.selectService.getSelectedAddress(this.selectedAddress);
    //     console.log(this.selectedAddress);
    // }

    trackByFn(driver: Driver) {
        return driver.shipment_id;
    }

    onGetSearchOrderNumber(value: string) {
        this.searchService.getSearchOrderNumber(value);
        console.log(this.searchOrderNumber);
    }

    onGetSearchRequestNumber(value: string) {
        this.searchService.getSearchRequestNumber(value);
        console.log(this.searchRequestNumber);
    }

    onGetSearchPlantName(value: string) {
        this.searchService.getSearchPlantName(value);
        console.log(this.searchPlantName);
    }

    onGetSearchClientName(value: string) {
        this.searchService.getSearchClientName(value);
        console.log(this.searchClientName);
    }

    onGetSearchAddress(value: string) {
        this.searchService.getSearchAddress(value);
        console.log(this.searchAddress);
    }

    onGetSearchName(value: string) {
        this.searchService.getSearchName(value);
        console.log(this.searchName);
    }

    onGetSearchPhone(value: string) {
        this.searchService.getSearchPhone(value);
        console.log(this.searchPhone);
    }

    onGetSearchCarNumber(value: string) {
        this.searchService.getSearchCarNumber(value);
        console.log(this.searchCarNumber);
    }

    onGetSearchCarrier(value: string) {
        this.searchService.getSearchCarrier(value);
        console.log(this.searchCarrier);
    }

    onGetSearchStatus(value: string) {
        this.searchService.getSearchStatus(value);
        console.log(this.searchStatus);
    }

    onGetSearchDeliveryStatus(value: string) {
        this.searchService.getSearchDeliveryStatus(value);
        console.log(this.searchDeliveryStatus);
    }

    resetForm() {
        // this.form.reset();
        this.fields.forEach((item) => {
            item.control.markAsPristine();
        });
        this.name = '';
        this.phone = '';
        this.carNumber = '';
        this.carrier = '';
        this.orderNumber = '';
        this.requestNumber = '';
        this.plantName = null;
        this.clientName = '';
        this.address = '';
        this.status = null;
        this.deliveryStatus = null;
        this.searchService.getSearchName(this.name);
        this.searchService.getSearchPhone(this.phone);
        this.searchService.getSearchCarNumber(this.carNumber);
        this.searchService.getSearchCarrier(this.carrier);
        this.searchService.getSearchOrderNumber(this.orderNumber);
        this.searchService.getSearchRequestNumber(this.requestNumber);
        this.searchService.getSearchPlantName(this.plantName);
        this.searchService.getSearchClientName(this.clientName);
        this.searchService.getSearchAddress(this.address);
        this.searchService.getSearchStatus(this.status);
        this.searchService.getSearchDeliveryStatus(this.deliveryStatus);
    }
}
